import { Box, Typography } from "@material-ui/core";

const AddressOneLiner = ({ address }) => {
  return (
    <Box display="flex">
      <Typography color="secondary" variant="caption">
        {address && address.postal_code
          ? [
              [address.street_number, address.street, address.postal_code, address.city].join(" "),
              address.extra_information ? `(${address.extra_information})` : "",
            ].join(", ")
          : "Pas d'adresse disponible"}
      </Typography>
    </Box>
  );
};

export default AddressOneLiner;
